module.exports = __webpack_public_path__ + "assets/img/banner1.aa27903f.png";